define.alias("shared/components/shared/modal/section", "media/components/shared/modal/section");